import { ytId } from '../components/course-editor/content/meta';

let ytApi;
const loadYT = () => {
  if (ytApi) return ytApi;
  ytApi = new Promise((resolve) => {
    if (window.YT?.Player) { resolve(window.YT); return; }
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => { prev?.(); resolve(window.YT); };
    const s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(s);
  });
  return ytApi;
};

const withTimeout = (p, ms) => Promise.race([p, new Promise(r => setTimeout(() => r(0), ms))]);

const youtubeSeconds = (id) => withTimeout(loadYT().then(YT => new Promise((resolve) => {
  const host = document.createElement('div');
  host.style.cssText = 'position:fixed;left:-9999px;top:0;width:200px;height:120px;';
  document.body.appendChild(host);
  const el = document.createElement('div');
  host.appendChild(el);
  let player;
  const done = (v) => { try { player?.destroy(); } catch (e) { /* noop */ } host.remove(); resolve(Math.round(v || 0)); };
  const read = () => player?.getDuration?.() || 0;
  player = new YT.Player(el, {
    videoId: id, width: 200, height: 120, playerVars: { mute: 1, controls: 0 },
    events: {
      onReady: () => { const d = read(); if (d) done(d); else { player.mute(); player.playVideo(); } },
      onStateChange: () => { const d = read(); if (d) done(d); },
      onError: () => done(0),
    },
  });
})), 20000);

const mediaSeconds = (src) => withTimeout(new Promise((resolve) => {
  const v = document.createElement('video');
  v.preload = 'metadata';
  v.muted = true;
  v.onloadedmetadata = () => resolve(Number.isFinite(v.duration) ? Math.round(v.duration) : 0);
  v.onerror = () => resolve(0);
  v.src = src;
}), 20000);

export const getVideoSeconds = async ({ file, url, youtube }) => {
  if (file) {
    const obj = URL.createObjectURL(file);
    try { return await mediaSeconds(obj); } finally { URL.revokeObjectURL(obj); }
  }
  if (url) return mediaSeconds(url.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
  const id = ytId(youtube);
  return id ? youtubeSeconds(id) : 0;
};
